import { Card } from 'apps/shared/scripts/__generated__/graphql.generated';
import { LabelValue } from 'apps/shared/scripts/components';

import { widgetBodyClassName } from './styles';

type Props = Pick<Card, 'headline' | 'recipientName'>;

const WidgetBody = ({ headline, recipientName }: Props) => {
  return (
    <div className={widgetBodyClassName}>
      <LabelValue label="Recipient" value={recipientName} />
      <LabelValue label="Title" value={headline} />
    </div>
  );
};

WidgetBody.displayName = 'WidgetBody';

export default WidgetBody;
